<template>
  <div>
    <v-card>
      <v-card-title class="text-h5 grey lighten-3">{{ formTitle }}</v-card-title>
      <v-card-text>
        <v-alert
          class="mb-4 mt-2"
          color="primary"
          icon="fal fa-exclamation-square"
          outlined
          prominent
          text
        > {{ $t('This note will be visible on the printed receipt.') }} </v-alert>
        <form-wrapper :validator="$v.receipt">
          <v-form ref="form">
            <form-group name="note">
              <template v-slot:default="{attrs}">
                <v-textarea
                  ref="input"
                  v-bind="attrs"
                  v-model="note"
                  auto-grow
                  counter="255"
                  filled
                  flat
                />
              </template>
            </form-group>
          </v-form>
        </form-wrapper>
        <v-divider />
      </v-card-text>
      <v-card-actions>
        <v-slide-y-transition>
          <v-btn
            v-show="note"
            color="red"
            text
            @click="removeNote(receipt.uuid)"
          >
            <v-icon
              class="mr-2"
              small
            >fal fa-trash-alt</v-icon>
            {{ $t('Delete') }}
          </v-btn>
        </v-slide-y-transition>
        <v-spacer />
        <v-btn
          :loading="$wait.is('saving note')"
          class="font-weight-bold"
          color="primary"
          text
          @click="submit"
        > {{ $t('Save') }} </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import validationMixin from '@/utils/mixins/validationMixin'
import focusInputMixin from '@/utils/mixins/focusInputMixin'
import { maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'FormsNotesSave',

  mixins: [ validationMixin, focusInputMixin ],

  props: {
    formTitle: {
      default: '',
      type: String
    },
    receiptObject: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    note: null,
    receipt: null
  }),

  validations () {
    const validations = {
      receipt: {
        note: {
          maxLength: maxLength(255)
        }
      }
    }
    return validations
  },

  watch: {
    receiptObject: {
      immediate: true,
      handler (receiptObject) {
        this.receipt = Object.assign({}, receiptObject)
        this.note = this.receipt.note
      }
    }
  },

  methods: {
    submit () {
      if (!this.validate()) return
      this.$wait.start('saving note')
      return this.$store.dispatch('RECEIPT/ADD_NOTE', { receiptUuid: this.receipt.uuid, note: this.note })
        .then((data) => {
          this.helpers.toastSuccess(data.message)
          this.$emit('saved', data)
        })
        .catch(data => { if (data && data.message) this.helpers.toastError(data.message) })
        .finally(() => this.$wait.end('saving note'))
    },
    removeNote (receiptId) {
      this.$wait.start('saving note')
      return this.$store.dispatch('RECEIPT/REMOVE_NOTE', { receiptUuid: this.receipt.uuid })
        .then((data) => {
          this.helpers.toastSuccess(data.message)
          this.$emit('saved', data)
        })
        .catch(data => { if (data && data.message) this.helpers.toastError(data.message) })
        .finally(() => this.$wait.end('saving note'))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/notes/FormsNotesSave.vue